import type { ActivityBonusBreakdownItem, RoomActivity } from './rooms';

export function mapBonusBreakdown(value: unknown): ActivityBonusBreakdownItem[] {
  if (!Array.isArray(value)) return [];
  return value.flatMap((item): ActivityBonusBreakdownItem[] => {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return [];
    const points = Number(item.points);
    if (!Number.isFinite(points) || points <= 0) return [];
    if (typeof item.gearInstanceId === 'string' && item.gearInstanceId
      && typeof item.gearId === 'string' && item.gearId) {
      return [{ gearInstanceId: item.gearInstanceId, gearId: item.gearId, points }];
    }
    return typeof item.talentId === 'string' && item.talentId ? [{ talentId: item.talentId, points }] : [];
  });
}

export function formatActivityBonusSummary(activity: Pick<RoomActivity, 'bonusPoints' | 'bonusBreakdown'>): string {
  const gearPoints = activity.bonusBreakdown.reduce(
    (sum, item) => sum + ('gearInstanceId' in item ? item.points : 0), 0,
  );
  // Older activities can have a talent total without a detailed breakdown.
  return `Talent bonus +${activity.bonusPoints - gearPoints} pts · Gear bonus +${gearPoints} pts`;
}
